import BodyHeader from "@app/shared/components/BodyHeader";
import { FlexCol } from "@design-system/Layout/Flex";
import { PageContainer } from "@design-system/Layout/PageContainer";
import { useState, type FC } from "react";
import { QuestionsHeader } from "./components/QuestionsHeader";
import { QuestionTable } from "./components/QuestionTable";
import { useSupplierTemplateQuestionnaire } from "./data";
import { useSupplierQuestionsPageTranslations } from "./i18n";
import { type QuestionFilter } from "./types";

export const Questions: FC = () => {
    const { templateQuestionnaire, isPending: isTemplateQuestionnairePending } =
        useSupplierTemplateQuestionnaire();

    const [filters, setFilters] = useState<QuestionFilter>({
        types: [],
        tagIds: [],
        questionGroupIds: [],
    });

    const { t, keys } = useSupplierQuestionsPageTranslations();
    return (
        <PageContainer>
            <BodyHeader title={t(keys.title)} subTitle={t(keys.subTitle)} />
            <FlexCol p="4" gap="4" w="full">
                <QuestionsHeader
                    templateQuestionnaire={templateQuestionnaire}
                    filters={filters}
                    onFiltersChange={setFilters}
                />
                <QuestionTable
                    isLoading={isTemplateQuestionnairePending}
                    questionnaireId={templateQuestionnaire?.id}
                    chipFilters={filters}
                />
            </FlexCol>
        </PageContainer>
    );
};
